import {useInfiniteQuery} from 'react-query';
import {getMessagesChats} from '.';

const useGetMessagesChats = (guid?: string) => {
  const {data, isLoading, hasNextPage, fetchNextPage, refetch} =
    useInfiniteQuery({
      cacheTime: 0,
      enabled: guid ? true : false,
      queryKey: ['massegs-chats', guid],
      queryFn: ({pageParam = 1}) => {
        return getMessagesChats(pageParam, guid);
      },
      getNextPageParam: (_, allPages) => {
        return allPages[allPages.length - 1]?.next
          ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
              'page',
            )
          : undefined;
      },
    });

  return {data, isLoading, hasNextPage, fetchNextPage, refetch};
};

export default useGetMessagesChats;
